$(function() {
		
	ele.search = {
			
		articles: {
			$container: $(".searchResults--articles"),
			$pagination: $(".searchResults--articles").find(".searchResults-pagination"),
			$results: $(".searchResults--articles").find(".searchResults-result"),
			count: 0,
			page: 0,
			perPage: 10
		},
		
		products: {
			$container: $(".searchResults--products"),
			$pagination: $(".searchResults--products").find(".searchResults-pagination"),
			$results: $(".searchResults--products").find(".searchResults-result"),
			count: 0,
			page: 0,
			perPage: 5
		},
		
		init: function() {
			
			this.articles.count = this.articles.$results.length;
			this.products.count = this.products.$results.length;

			this.updateVisible();
			this.updatePagination();

			$(".searchResults-pagination .btn-pagination-prev").on("click", this.prev);
			$(".searchResults-pagination .btn-pagination-next").on("click", this.next);
			
		},
		

		prev: function(e){			
			var $target = $(e.target);
			if (!$target.attr("disabled")) {
				if ($target.closest(".searchResults").hasClass("searchResults--articles")) {
					ele.search.articles.page--; //no this context here
				} else {
					ele.search.products.page--;
				}	
				ele.search.updateVisible();
				ele.search.updatePagination();		
			}
		},
		
		next: function(e){			
			var $target = $(e.target);
			if (!$target.attr("disabled")) {
				if ($target.closest(".searchResults").hasClass("searchResults--articles")) {
					ele.search.articles.page++;
				} else {
					ele.search.products.page++;
				}			
	
				ele.search.updateVisible();
				ele.search.updatePagination();
			}
		},
		
		updateVisible: function() {
			
			this.articles.$results.css("display", "none");
			this.products.$results.css("display", "none");

			this.articles.$results.slice(
				this.articles.page*this.articles.perPage, 
				(this.articles.page+1)*this.articles.perPage
			).css("display", "block");
			
			this.products.$results.slice(
				this.products.page*this.products.perPage, 
				(this.products.page+1)*this.products.perPage
			).css("display", "block");

		},
			
		updatePagination: function() {

			if (this.articles.count <= this.articles.perPage) { this.articles.$pagination.remove(); }
			if (this.products.count <= this.products.perPage) { this.products.$pagination.remove(); }

			//numbering
			this.articles.$pagination.find(".pagination-current").text(this.articles.page + 1);
			this.articles.$pagination.find(".pagination-end").text(Math.ceil(this.articles.count/this.articles.perPage));
			
			this.products.$pagination.find(".pagination-current").text(this.products.page + 1);
			this.products.$pagination.find(".pagination-end").text(Math.ceil(this.products.count/this.products.perPage));
			
						
			//enable/disable buttons
			this.articles.$pagination.find(".btn-pagination-prev, .btn-pagination-next").attr("disabled", false);
			this.products.$pagination.find(".btn-pagination-prev, .btn-pagination-next").attr("disabled", false);

			if (this.articles.page == 0) { this.articles.$pagination.find(".btn-pagination-prev").attr("disabled", true); }
			if (this.articles.page == Math.ceil(this.articles.count/this.articles.perPage)-1) { this.articles.$pagination.find(".btn-pagination-next").attr("disabled", true); }
			
			if (this.products.page == 0) { this.products.$pagination.find(".btn-pagination-prev").attr("disabled", true); }
			if (this.products.page == Math.ceil(this.products.count/this.products.perPage)-1) { this.products.$pagination.find(".btn-pagination-next").attr("disabled", true); }

		}
		
	};
	
	
	if ($("#search-results-page").length > 0) {
		ele.search.init();
		
		if ($("#searchForm").length > 0){
			$("#searchForm").find(".btn-search").on("click", function(){
				$(this).closest("form").submit();
			});
		}
	}
	
});